//#region src/interpreter/comparators.ts
var e = {
	eq: (e, t) => e === t,
	neq: (e, t) => e !== t,
	beginsWith: (e, t) => e.startsWith(t),
	endsWith: (e, t) => e.endsWith(t),
	matches: (e, t) => {
		try {
			return RegExp(`^${t}$`).test(e);
		} catch {
			return !1;
		}
	}
}, t = {
	eq: (e, t) => e === t,
	gt: (e, t) => e > t,
	lt: (e, t) => e < t
}, n = { eq: (e, t) => e === t }, r = {
	containsOne: (e, t) => t.some((t) => e.includes(t)),
	containsAll: (e, t) => t.every((t) => e.includes(t)),
	isEmpty: (e) => e.length === 0
};
function i(e) {
	return new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate())).getTime();
}
function a(e) {
	return new Date(Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), 23, 59, 59, 999)).getTime();
}
function o() {
	return /* @__PURE__ */ new Date();
}
var s = {
	before: (e, t) => {
		let n = o();
		return e < i(/* @__PURE__ */ new Date(n.getTime() - t * 24 * 60 * 60 * 1e3));
	},
	after: (e, t) => {
		let n = o();
		return e > a(new Date(n.getTime() + t * 24 * 60 * 60 * 1e3));
	}
}, c = {
	gt: (e, t) => e > t,
	lt: (e, t) => e < t
};
function l(e, t) {
	let n;
	return n = e.symbol === "+" ? t + e.offset : t - e.offset, n < 0 ? n + 24 : n >= 24 ? n - 24 : n;
}
var u = {
	between: (e, t, n, r) => {
		let i = l(r, e), a = l(r, t), o = l(r, n);
		return a <= o ? i >= a && i <= o : i >= a || i <= o;
	},
	notBetween: (e, t, n, r) => !u.between(e, t, n, r)
};
//#endregion
//#region src/interpreter/evaluate.ts
function d(e, t) {
	let n = [], r = f(e, t, n), i = n.filter((e) => e.passed && e.segment !== void 0).map((e) => e.segment);
	return {
		passed: r.passed,
		segmentsPassed: i
	};
}
function f(e, t, n) {
	switch (e.type) {
		case "And": return p(e, t, n);
		case "Or": return m(e, t, n);
		case "Not": return h(e, t, n);
		case "StringField": return g(e, t);
		case "NumberField": return _(e, t);
		case "BooleanField": return v(e, t);
		case "DateField": return y(e, t);
		case "TimeField": return b(e, t);
		case "StringArrayField": return x(e, t);
		case "HourTimezoneField": return S(e, t);
		default: throw Error(`Unknown expression type: ${e.type}`);
	}
}
function p(e, t, n) {
	let r = {
		passed: e.children.map((e) => f(e, t, n)).every((e) => e.passed),
		segment: e.segment
	};
	return e.segment && n.push(r), r;
}
function m(e, t, n) {
	let r = {
		passed: e.children.map((e) => f(e, t, n)).some((e) => e.passed),
		segment: e.segment
	};
	return e.segment && n.push(r), r;
}
function h(e, t, n) {
	return { passed: !f(e.child, t, n).passed };
}
function g(t, n) {
	let r = n.getString(t.fieldName);
	if (r === void 0) return { passed: !1 };
	let i;
	switch (t.comparator) {
		case "==":
			i = e.eq(r, t.value);
			break;
		case "!=":
			i = e.neq(r, t.value);
			break;
		case "begins_with":
			i = e.beginsWith(r, t.value);
			break;
		case "ends_with":
			i = e.endsWith(r, t.value);
			break;
		case "matches":
			i = e.matches(r, t.value);
			break;
		default: i = !1;
	}
	return { passed: i };
}
function _(e, n) {
	let r = n.getNumber(e.fieldName);
	if (r === void 0) return { passed: !1 };
	let i;
	switch (e.comparator) {
		case "==":
			i = t.eq(r, e.value);
			break;
		case ">":
			i = t.gt(r, e.value);
			break;
		case "<":
			i = t.lt(r, e.value);
			break;
		default: i = !1;
	}
	return { passed: i };
}
function v(e, t) {
	let r = t.getBoolean(e.fieldName);
	return r === void 0 ? { passed: !1 } : { passed: n.eq(r, e.value) };
}
function y(e, t) {
	let n = t.getLong(e.fieldName);
	if (n === void 0) return { passed: !1 };
	let r;
	switch (e.comparator) {
		case "before":
			r = s.before(n, e.duration.length);
			break;
		case "after":
			r = s.after(n, e.duration.length);
			break;
		default: r = !1;
	}
	return { passed: r };
}
function b(e, t) {
	let n = t.getInt(e.fieldName);
	if (n === void 0) return { passed: !1 };
	let r;
	switch (e.comparator) {
		case ">":
			r = c.gt(n, e.duration.length);
			break;
		case "<":
			r = c.lt(n, e.duration.length);
			break;
		default: r = !1;
	}
	return { passed: r };
}
function x(e, t) {
	let n = t.getStringList(e.fieldName);
	if (e.comparator === "is_empty") return { passed: n === void 0 || r.isEmpty(n) };
	if (n === void 0) return { passed: !1 };
	let i;
	switch (e.comparator) {
		case "contains_one":
			i = r.containsOne(n, e.values);
			break;
		case "contains_all":
			i = r.containsAll(n, e.values);
			break;
		default: i = !1;
	}
	return { passed: i };
}
function S(e, t) {
	let n = t.getInt(e.fieldName);
	if (n === void 0) return { passed: !1 };
	let r;
	switch (e.comparator) {
		case "between":
			r = u.between(n, e.hourStart, e.hourEnd, e.offset);
			break;
		case "not_between":
			r = u.notBetween(n, e.hourStart, e.hourEnd, e.offset);
			break;
		default: r = !1;
	}
	return { passed: r };
}
//#endregion
//#region src/parser/lexer.ts
var C = class {
	input;
	position = 0;
	tokens = [];
	constructor(e) {
		this.input = e;
	}
	tokenize() {
		for (this.tokens = [], this.position = 0; this.position < this.input.length && (this.skipWhitespace(), !(this.position >= this.input.length));) {
			let e = this.nextToken();
			e && this.tokens.push(e);
		}
		return this.tokens.push({
			type: "EOF",
			value: "",
			position: this.position
		}), this.tokens;
	}
	skipWhitespace() {
		for (; this.position < this.input.length && /\s/.test(this.input[this.position]);) this.position++;
	}
	peek(e = 0) {
		return this.input[this.position + e] || "";
	}
	nextToken() {
		let e = this.position, t = this.peek();
		if (t === "(") return this.position++, {
			type: "LPAREN",
			value: "(",
			position: e
		};
		if (t === ")") return this.position++, {
			type: "RPAREN",
			value: ")",
			position: e
		};
		if (t === "[") return this.position++, {
			type: "LBRACKET",
			value: "[",
			position: e
		};
		if (t === "]") return this.position++, {
			type: "RBRACKET",
			value: "]",
			position: e
		};
		if (t === ",") return this.position++, {
			type: "COMMA",
			value: ",",
			position: e
		};
		if (t === "+") return this.position++, {
			type: "PLUS",
			value: "+",
			position: e
		};
		if (t === "-" && !/\d/.test(this.peek(1))) return this.position++, {
			type: "MINUS",
			value: "-",
			position: e
		};
		if (t === "=" && this.peek(1) === "=") return this.position += 2, {
			type: "EQ",
			value: "==",
			position: e
		};
		if (t === "!" && this.peek(1) === "=") return this.position += 2, {
			type: "NEQ",
			value: "!=",
			position: e
		};
		if (t === ">") return this.position++, {
			type: "GT",
			value: ">",
			position: e
		};
		if (t === "<") return this.position++, {
			type: "LT",
			value: "<",
			position: e
		};
		if (t === "\"" || t === "'") return this.readString(t);
		if (/\d/.test(t) || t === "-" && /\d/.test(this.peek(1))) return this.readNumber();
		if (/[a-zA-Z_]/.test(t)) return this.readKeywordOrIdent();
		throw Error(`Unexpected character '${t}' at position ${e}`);
	}
	readString(e) {
		let t = this.position;
		this.position++;
		let n = "";
		for (; this.position < this.input.length;) {
			let r = this.peek();
			if (r === e) return this.position++, {
				type: "STRING",
				value: n,
				position: t
			};
			if (r === "\\" && this.position + 1 < this.input.length) {
				this.position++;
				let e = this.peek();
				e === "n" ? n += "\n" : e === "t" ? n += "	" : e === "r" ? n += "\r" : n += e, this.position++;
			} else n += r, this.position++;
		}
		throw Error(`Unterminated string starting at position ${t}`);
	}
	readNumber() {
		let e = this.position, t = "";
		for (this.peek() === "-" && (t += "-", this.position++); this.position < this.input.length && /\d/.test(this.peek());) t += this.peek(), this.position++;
		if (this.peek() === "." && /\d/.test(this.peek(1))) for (t += ".", this.position++; this.position < this.input.length && /\d/.test(this.peek());) t += this.peek(), this.position++;
		return {
			type: "NUMBER",
			value: t,
			position: e
		};
	}
	readKeywordOrIdent() {
		let e = this.position, t = "";
		for (; this.position < this.input.length && /[a-zA-Z0-9_-]/.test(this.peek());) t += this.peek(), this.position++;
		let n = t.toUpperCase(), r = t.toLowerCase(), i = {
			sfield: "SFIELD",
			nfield: "NFIELD",
			bfield: "BFIELD",
			dfield: "DFIELD",
			tfield: "TFIELD",
			safield: "SAFIELD",
			htzfield: "HTZFIELD",
			AND: "AND",
			OR: "OR",
			NOT: "NOT",
			begins_with: "BEGINS_WITH",
			ends_with: "ENDS_WITH",
			matches: "MATCHES",
			contains_one: "CONTAINS_ONE",
			contains_all: "CONTAINS_ALL",
			is_empty: "IS_EMPTY",
			between: "BETWEEN",
			not_between: "NOT_BETWEEN",
			before: "BEFORE",
			after: "AFTER",
			days: "DAYS",
			seconds: "SECONDS",
			time_period: "TIME_PERIOD",
			segment: "SEGMENT",
			true: "TRUE",
			false: "FALSE"
		};
		return i[t] ? {
			type: i[t],
			value: t,
			position: e
		} : i[r] ? {
			type: i[r],
			value: t,
			position: e
		} : i[n] ? {
			type: i[n],
			value: t,
			position: e
		} : {
			type: "IDENT",
			value: t,
			position: e
		};
	}
}, w = class {
	tokens = [];
	position = 0;
	parse(e) {
		let t = new C(e);
		this.tokens = t.tokenize(), this.position = 0;
		let n = this.parseExpr();
		if (!this.isAtEnd()) throw Error(`Unexpected token '${this.current().value}' at position ${this.current().position}`);
		return n;
	}
	parseExpr() {
		return this.parseLogicalOrField();
	}
	parseLogicalOrField() {
		let e = this.current();
		switch (e.type) {
			case "AND": return this.parseAnd();
			case "OR": return this.parseOr();
			case "NOT": return this.parseNot();
			case "SFIELD": return this.parseSfield();
			case "NFIELD": return this.parseNfield();
			case "BFIELD": return this.parseBfield();
			case "DFIELD": return this.parseDfield();
			case "TFIELD": return this.parseTfield();
			case "SAFIELD": return this.parseSafield();
			case "HTZFIELD": return this.parseHtzfield();
			case "LBRACKET": return this.parseTimePeriodPrefixedNfield();
			default: throw Error(`Unexpected token '${e.value}' at position ${e.position}`);
		}
	}
	parseAnd() {
		this.expect("AND");
		let e = this.parseOptionalSegment();
		this.expect("LPAREN");
		let t = this.parseExprList();
		return this.expect("RPAREN"), {
			type: "And",
			segment: e,
			children: t
		};
	}
	parseOr() {
		this.expect("OR");
		let e = this.parseOptionalSegment();
		this.expect("LPAREN");
		let t = this.parseExprList();
		return this.expect("RPAREN"), {
			type: "Or",
			segment: e,
			children: t
		};
	}
	parseNot() {
		this.expect("NOT"), this.expect("LPAREN");
		let e = this.parseExpr();
		return this.expect("RPAREN"), {
			type: "Not",
			child: e
		};
	}
	parseOptionalSegment() {
		if (this.check("LBRACKET")) {
			this.advance(), this.expect("SEGMENT");
			let e = this.expect("IDENT", "NUMBER", "STRING");
			return this.expect("RBRACKET"), e.value;
		}
	}
	parseExprList() {
		let e = [];
		for (e.push(this.parseExpr()); this.check("COMMA");) this.advance(), e.push(this.parseExpr());
		return e;
	}
	parseSfield() {
		return this.expect("SFIELD"), {
			type: "StringField",
			fieldName: this.expect("IDENT").value,
			comparator: this.parseStringComparator(),
			value: this.expect("STRING").value
		};
	}
	parseStringComparator() {
		let e = this.current();
		switch (e.type) {
			case "EQ": return this.advance(), "==";
			case "NEQ": return this.advance(), "!=";
			case "BEGINS_WITH": return this.advance(), "begins_with";
			case "ENDS_WITH": return this.advance(), "ends_with";
			case "MATCHES": return this.advance(), "matches";
			default: throw Error(`Expected string comparator, got '${e.value}' at position ${e.position}`);
		}
	}
	parseNfield() {
		this.expect("NFIELD");
		let e;
		if (this.check("LBRACKET")) {
			this.advance(), this.expect("TIME_PERIOD");
			let t = parseFloat(this.expect("NUMBER").value);
			this.expect("DAYS"), this.expect("RBRACKET"), e = {
				length: t,
				unit: "days"
			};
		}
		return {
			type: "NumberField",
			fieldName: this.expect("IDENT").value,
			comparator: this.parseNumberComparator(),
			value: parseFloat(this.expect("NUMBER").value),
			timePeriod: e
		};
	}
	parseTimePeriodPrefixedNfield() {
		this.expect("LBRACKET"), this.expect("TIME_PERIOD");
		let e = parseFloat(this.expect("NUMBER").value);
		this.expect("DAYS"), this.expect("RBRACKET");
		let t = {
			length: e,
			unit: "days"
		};
		return this.expect("NFIELD"), {
			type: "NumberField",
			fieldName: this.expect("IDENT").value,
			comparator: this.parseNumberComparator(),
			value: parseFloat(this.expect("NUMBER").value),
			timePeriod: t
		};
	}
	parseNumberComparator() {
		let e = this.current();
		switch (e.type) {
			case "EQ": return this.advance(), "==";
			case "GT": return this.advance(), ">";
			case "LT": return this.advance(), "<";
			default: throw Error(`Expected number comparator, got '${e.value}' at position ${e.position}`);
		}
	}
	parseBfield() {
		this.expect("BFIELD");
		let e = this.expect("IDENT").value;
		this.expect("EQ");
		let t = this.current(), n;
		if (t.type === "TRUE") n = !0, this.advance();
		else if (t.type === "FALSE") n = !1, this.advance();
		else throw Error(`Expected boolean value, got '${t.value}' at position ${t.position}`);
		return {
			type: "BooleanField",
			fieldName: e,
			comparator: "==",
			value: n
		};
	}
	parseDfield() {
		this.expect("DFIELD");
		let e = this.expect("IDENT").value, t = this.parseDateComparator(), n = parseFloat(this.expect("NUMBER").value);
		return this.expect("DAYS"), {
			type: "DateField",
			fieldName: e,
			comparator: t,
			duration: {
				length: n,
				unit: "days"
			}
		};
	}
	parseDateComparator() {
		let e = this.current();
		switch (e.type) {
			case "BEFORE": return this.advance(), "before";
			case "AFTER": return this.advance(), "after";
			default: throw Error(`Expected date comparator (before/after), got '${e.value}' at position ${e.position}`);
		}
	}
	parseTfield() {
		this.expect("TFIELD");
		let e = this.expect("IDENT").value, t = this.parseTimeComparator(), n = parseFloat(this.expect("NUMBER").value);
		return this.expect("SECONDS"), {
			type: "TimeField",
			fieldName: e,
			comparator: t,
			duration: {
				length: n,
				unit: "seconds"
			}
		};
	}
	parseTimeComparator() {
		let e = this.current();
		switch (e.type) {
			case "GT": return this.advance(), ">";
			case "LT": return this.advance(), "<";
			default: throw Error(`Expected time comparator (>/< ), got '${e.value}' at position ${e.position}`);
		}
	}
	parseSafield() {
		this.expect("SAFIELD");
		let e = this.expect("IDENT").value, t = this.parseArrayComparator();
		if (t === "is_empty") return {
			type: "StringArrayField",
			fieldName: e,
			comparator: t,
			values: []
		};
		this.expect("LBRACKET");
		let n = [];
		if (!this.check("RBRACKET")) for (n.push(this.expect("STRING").value); this.check("COMMA");) this.advance(), n.push(this.expect("STRING").value);
		return this.expect("RBRACKET"), {
			type: "StringArrayField",
			fieldName: e,
			comparator: t,
			values: n
		};
	}
	parseArrayComparator() {
		let e = this.current();
		switch (e.type) {
			case "CONTAINS_ONE": return this.advance(), "contains_one";
			case "CONTAINS_ALL": return this.advance(), "contains_all";
			case "IS_EMPTY": return this.advance(), "is_empty";
			default: throw Error(`Expected array comparator, got '${e.value}' at position ${e.position}`);
		}
	}
	parseHtzfield() {
		this.expect("HTZFIELD");
		let e = {
			symbol: "+",
			offset: 0
		};
		if (this.check("LBRACKET")) {
			this.advance();
			let t = this.current();
			if (t.type === "PLUS") e.symbol = "+", this.advance(), e.offset = parseFloat(this.expect("NUMBER").value);
			else if (t.type === "MINUS") e.symbol = "-", this.advance(), e.offset = parseFloat(this.expect("NUMBER").value);
			else if (t.type === "NUMBER") {
				let n = parseFloat(t.value);
				n < 0 ? (e.symbol = "-", e.offset = Math.abs(n)) : e.offset = n, this.advance();
			}
			this.expect("RBRACKET");
		}
		let t = this.expect("IDENT").value, n = this.parseHourComparator(), r = parseFloat(this.expect("NUMBER").value);
		return this.expect("COMMA"), {
			type: "HourTimezoneField",
			fieldName: t,
			comparator: n,
			offset: e,
			hourStart: r,
			hourEnd: parseFloat(this.expect("NUMBER").value)
		};
	}
	parseHourComparator() {
		let e = this.current();
		switch (e.type) {
			case "BETWEEN": return this.advance(), "between";
			case "NOT_BETWEEN": return this.advance(), "not_between";
			default: throw Error(`Expected hour comparator (between/not_between), got '${e.value}' at position ${e.position}`);
		}
	}
	current() {
		return this.tokens[this.position] || {
			type: "EOF",
			value: "",
			position: -1
		};
	}
	isAtEnd() {
		return this.current().type === "EOF";
	}
	check(...e) {
		return e.includes(this.current().type);
	}
	advance() {
		return this.isAtEnd() || this.position++, this.tokens[this.position - 1];
	}
	expect(...e) {
		let t = this.current();
		if (!e.includes(t.type)) throw Error(`Expected ${e.join(" or ")}, got '${t.value}' at position ${t.position}`);
		return this.advance();
	}
};
function T(e) {
	return new w().parse(e);
}
//#endregion
//#region src/types/ast.ts
function E(e) {
	return "field_type" in e;
}
function D(e) {
	return "logicalOp" in e;
}
//#endregion
//#region src/parser/json.ts
function O(e) {
	return k(JSON.parse(e));
}
function k(e) {
	if (D(e)) return A(e);
	if (E(e)) return j(e);
	throw Error("Invalid Elevion JSON: must be a leaf or node expression");
}
function A(e) {
	let t = e.nodes.map(k), n = e.segment || void 0;
	switch (e.logicalOp) {
		case "AND": return {
			type: "And",
			segment: n,
			children: t
		};
		case "OR": return {
			type: "Or",
			segment: n,
			children: t
		};
		case "NOT":
			if (t.length !== 1) throw Error("NOT expression must have exactly one child");
			return {
				type: "Not",
				child: t[0]
			};
		default: throw Error(`Unknown logical operator: ${e.logicalOp}`);
	}
}
function j(e) {
	switch (e.field_type) {
		case "sfield": return M(e);
		case "nfield": return N(e);
		case "bfield": return P(e);
		case "dfield": return F(e);
		case "tfield": return I(e);
		case "safield": return L(e);
		case "htzfield": return R(e);
		default: throw Error(`Unknown field type: ${e.field_type}`);
	}
}
function M(e) {
	let t = e.comparator;
	if (![
		"==",
		"!=",
		"begins_with",
		"ends_with",
		"matches"
	].includes(t)) throw Error(`Invalid comparator for sfield: ${e.comparator}`);
	return {
		type: "StringField",
		fieldName: e.field,
		comparator: t,
		value: String(e.value)
	};
}
function N(e) {
	let t = e.comparator;
	if (![
		"==",
		">",
		"<"
	].includes(t)) throw Error(`Invalid comparator for nfield: ${e.comparator}`);
	let n;
	if (e.data_time_period) {
		let t = e.data_time_period.match(/^(\d+)\s*days?$/i);
		t && (n = {
			length: parseInt(t[1], 10),
			unit: "days"
		});
	}
	return {
		type: "NumberField",
		fieldName: e.field,
		comparator: t,
		value: Number(e.value),
		timePeriod: n
	};
}
function P(e) {
	if (e.comparator !== "==") throw Error(`Invalid comparator for bfield: ${e.comparator}`);
	let t;
	return t = typeof e.value == "boolean" ? e.value : typeof e.value == "string" ? e.value.toLowerCase() === "true" : !!e.value, {
		type: "BooleanField",
		fieldName: e.field,
		comparator: "==",
		value: t
	};
}
function F(e) {
	let t = e.comparator;
	if (!["before", "after"].includes(t)) throw Error(`Invalid comparator for dfield: ${e.comparator}`);
	let n = String(e.value).match(/^(\d+)\s*days?$/i);
	if (!n) throw Error(`Invalid dfield value format: ${e.value}`);
	return {
		type: "DateField",
		fieldName: e.field,
		comparator: t,
		duration: {
			length: parseInt(n[1], 10),
			unit: "days"
		}
	};
}
function I(e) {
	let t = e.comparator;
	if (![">", "<"].includes(t)) throw Error(`Invalid comparator for tfield: ${e.comparator}`);
	let n = String(e.value).match(/^(\d+)\s*seconds?$/i);
	if (!n) throw Error(`Invalid tfield value format: ${e.value}`);
	return {
		type: "TimeField",
		fieldName: e.field,
		comparator: t,
		duration: {
			length: parseInt(n[1], 10),
			unit: "seconds"
		}
	};
}
function L(e) {
	let t = e.comparator;
	if (![
		"contains_one",
		"contains_all",
		"is_empty"
	].includes(t)) throw Error(`Invalid comparator for safield: ${e.comparator}`);
	let n = [];
	return t !== "is_empty" && e.value !== null && (n = Array.isArray(e.value) ? e.value.map(String) : [String(e.value)]), {
		type: "StringArrayField",
		fieldName: e.field,
		comparator: t,
		values: n
	};
}
function R(e) {
	let t = e.comparator;
	if (!["between", "not_between"].includes(t)) throw Error(`Invalid comparator for htzfield: ${e.comparator}`);
	let n = {
		symbol: "+",
		offset: 0
	};
	if (e.tz_offset) {
		let t = e.tz_offset.match(/^([+-])(\d+)$/);
		t && (n = {
			symbol: t[1],
			offset: parseInt(t[2], 10)
		});
	}
	let r = String(e.value).match(/^(\d+)\s*,\s*(\d+)$/);
	if (!r) throw Error(`Invalid htzfield value format: ${e.value}`);
	return {
		type: "HourTimezoneField",
		fieldName: e.field,
		comparator: t,
		offset: n,
		hourStart: parseInt(r[1], 10),
		hourEnd: parseInt(r[2], 10)
	};
}
//#endregion
//#region src/types/values.ts
function z(e) {
	return e == null ? { type: "null" } : typeof e == "string" ? {
		type: "string",
		value: e
	} : typeof e == "number" ? {
		type: "number",
		value: e
	} : typeof e == "boolean" ? {
		type: "boolean",
		value: e
	} : Array.isArray(e) ? {
		type: "stringList",
		value: e.filter((e) => typeof e == "string")
	} : { type: "null" };
}
var B = class {
	data;
	constructor(e) {
		this.data = /* @__PURE__ */ new Map();
		for (let [t, n] of Object.entries(e)) this.data.set(t, z(n));
	}
	getString(e) {
		let t = this.data.get(e);
		if (t) {
			if (t.type === "string") return t.value;
			if (t.type === "number" || t.type === "boolean") return String(t.value);
		}
	}
	getNumber(e) {
		let t = this.data.get(e);
		if (t) {
			if (t.type === "number") return t.value;
			if (t.type === "string") {
				let e = parseFloat(t.value);
				return isNaN(e) ? void 0 : e;
			}
		}
	}
	getBoolean(e) {
		let t = this.data.get(e);
		if (t) {
			if (t.type === "boolean") return t.value;
			if (t.type === "string") {
				if (t.value.toLowerCase() === "true") return !0;
				if (t.value.toLowerCase() === "false") return !1;
			}
		}
	}
	getStringList(e) {
		let t = this.data.get(e);
		if (t) {
			if (t.type === "stringList") return t.value;
			if (t.type === "string") return [t.value];
		}
	}
	getInt(e) {
		let t = this.getNumber(e);
		return t === void 0 ? void 0 : Math.floor(t);
	}
	getLong(e) {
		return this.getNumber(e);
	}
}, V = {
	eval(e, t) {
		return d(T(e), new B(t)).passed;
	},
	evalJson(e, t) {
		return d(O(e), new B(t)).passed;
	},
	evalFull(e, t) {
		return d(T(e), new B(t));
	},
	evalJsonFull(e, t) {
		return d(O(e), new B(t));
	}
};
//#endregion
export { V as Elevion, B as ElevionMap, d as evaluate, T as parseDsl, O as parseJson };

//# sourceMappingURL=index.js.map